<template>
  <CardContainer>
    <template v-slot:title>
      {{ text.pages.search.title }}
    </template>
    <template v-slot:content v-if="productList">
      <v-row>
        <v-col cols="6" md="3" v-for="product in productList" :key="'search_prod'+product.id">
          <ProductTileNew :product="product"/>
        </v-col>
        <v-col cols="12" md="6" offset-md="3" v-if="productList.length === 0">
          <img src="/img/norbit_niczego-nie-znaleziono.png" />
        </v-col>
      </v-row>
    </template>
  </CardContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import ProductTileNew from '@/components/Partials/ShopBody/ProductTileNew.vue';
import CardContainer from '@/components/Partials/CardContainer.vue';
import { state } from '../../store/index';

export default {
  name: 'SearchView',
  components: { CardContainer, ProductTileNew },
  mounted() {
    this.hasProductLists();
  },
  methods: {
    hasProductLists() {
      if (!this.productList) {
        this.$router.push('/');
      }
    },
  },
  computed: {
    text() {
      return translations[state.language];
    },
    productList() {
      return state.productsList;
    },
  },
};
</script>

<style scoped>
</style>
